import { ProjectSummaryListInfo } from '~/api/repository'
import { EcosystemProjectSummaryModel } from '~/types/model/ecosystem/project-detail.model'

export class EcosystemSearchListModel {
  private readonly _totalCount: string
  private readonly _projectSummaryList: Array<EcosystemProjectSummaryModel>

  constructor (res: ProjectSummaryListInfo) {
    this._totalCount = setComma(res.TCNT)
    this._projectSummaryList = res.PSMILIST.map(project => new EcosystemProjectSummaryModel({
      projectId: project.PID,
      name: project.NM,
      categoryList: project.CATGLIST,
      logoUrl: project.LGURL,
      description: project.TI,
      officialLink: project.OFFLK
    }))
  }

  get totalCount () {
    return this._totalCount
  }

  get projectSummaryList () {
    return this._projectSummaryList
  }
}